import { createFileRoute } from '@tanstack/react-router';

import { CookiePolicyPage } from '~/components/legal/CookiePolicyPage';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const CookiePolicy = () => {
  return <CookiePolicyPage />;
};

export const Route = createFileRoute('/cookies')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: CookiePolicy,
});

